import { createRoot } from "react-dom/client";
import { AudioLabApp } from "./src/AudioLabApp";
import "./src/lab.css";
import "./src/tracker.css";

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Adam: #root missing");
}

// No StrictMode — labRuntime binds imperative editors to LabShell DOM once.
(import.meta.hot.data.root ??= createRoot(rootEl)).render(<AudioLabApp />);
